import  React , {useState ,useEffect ,useRef} from 'react' ;
import { DataGrid } from '@material-ui/data-grid';
import fetchJson from '../lib/react-admin-loopback/fetch';

const columns = [
  { field: 'id', headerName: 'ID', width: 70 },
  { field: 'customerName', headerName: '기업명', width: 130 },
  { field: 'totalCount', headerName: '취식자 수', width: 130 },
  { field: 'likeCount', headerName: '좋아요 수', width: 130 },
  { field: 'likeRate', headerName: '좋아요 비율', width: 130 },
];

async function reqMenuSurveyUser(id){

    const apiUrl = process.env.REACT_APP_API_URL;
    
    const url = `${apiUrl}/menusurveys/` + id + `/surveyResult`;
  
    const { json } = await fetchJson(url);
    return { 
     data : json
  };
  }

export  function MenuSurveyUser({ id }) {
    const dataRef = useRef({ 
        reviews: [],    //  리뷰 data fetched
      });
      const [ loading, setLoading ] = useState(false);
      const [ error, setError ] = useState();

      useEffect(() => {
        const fetchData = async () => {
          try {
            // load 정산 자료 
            setLoading(true);
            const { data }  = await reqMenuSurveyUser(id);
            
            dataRef.current.reviews = data ;
            console.log (data) ;
            
            setLoading(false);
          }
          catch (err) {
            setError(err);
            setLoading(false);
            // LATER server logging  
            console.error(err);
          }
        }
        fetchData();
        
        }, [ id ]);   
  return (
    <div style={{ height: 400, width: '100%' }}>
      <DataGrid rows={dataRef.current.reviews} columns={columns} pageSize={5}  />
    </div>
  );
}